import { render } from "./AppLayoutPrivate.vue?vue&type=template&id=d1fcb3a8"
import script from "./AppLayoutPrivate.vue?vue&type=script&lang=js"
export * from "./AppLayoutPrivate.vue?vue&type=script&lang=js"

import "./AppLayoutPrivate.vue?vue&type=style&index=0&id=d1fcb3a8&lang=scss"

import exportComponent from "/Users/carloslazcanoyoung/PROJECT/MUSS/COMPANY/SOFOFA/IEE/iee-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__